<template>
    <div id="dashboard">
      <h1 class="subheading grey--text">Dashboard</h1>

      <v-container fluid class="my-5">

 <v-row row justify-start class="ma-3">
          <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-btn small flat color="grey lighten-3 mr-3" @click="sortBy('title')" v-on="on">
              <v-icon left small>folder</v-icon>
              <span right class="caption text-lowercase">by project name</span>
            </v-btn>
          </template>
          <span>Sorts projects by name</span>
        </v-tooltip>
        <v-btn small flat color="grey lighten-3" @click="sortBy('person')">
          <v-icon small align="left">person</v-icon>
          <span class="caption text-lowercase">By Person</span>
        </v-btn>
      </v-row>
          <v-card flat tile v-for="project in projects" :key="project.title">

              <v-row row wrap>

                    <v-col cols="12" md="6" :class="`pl-3 project ${project.status}`">
                      <div class="caption grey--text">Project Title</div>
                      <div>{{project.title}}</div>
                    </v-col>

                    <v-col xs="2">
                      <div class="caption grey--text">Person</div>
                      <div>{{project.person}}</div>
                    </v-col>

                    <v-col xs="2">
                      <div class="caption grey--text">Due Date</div>
                      <div>{{project.due}}</div>
                    </v-col>

                    <v-col xs="2">
                      <!-- <div class="caption grey--text">Status</div>
                      <div>{{project.status}}</div> -->
                      <div align="right">
                        <v-chip small :color="`${project.status}`" 
                        :class="`v-chip--active white--text caption my-2`">
                          {{project.status}}
                        </v-chip>
                      </div>
                    </v-col>

                  </v-row>

                  <v-row cols="12">
                  <v-divider></v-divider>
              </v-row>
          </v-card>

      </v-container>
    </div>
</template>

<script>
import db from '@/fb'
export default {
  data() {
    return{
     projects: [
            ]
    }
  },
   methods: {
    sortBy(prop) {
      this.projects.sort((a,b) => a[prop] < b[prop] ? -1 : 1)
    }
  }
  ,
   created() {
    db.collection('projects').onSnapshot(res => {
      const changes = res.docChanges();
      changes.forEach(change => {
        if (change.type === 'added') {
          this.projects.push({
            ...change.doc.data(),
            id: change.doc.id
          })
        }  
      })
    })
  }
}
</script>


<style>
.project.complete {
  border-left: 4px solid #3cd1c2;
}

.project.ongoing{
  border-left: 4px solid #e0c444;
}

.project.overdue{
  border-left: 4px solid #ce1c16;
}

.v-chip.ongoing {
    background: #fed330;
  }
.v-chip.complete {
    background: #3cd1c2;
  }
.v-chip.overdue {
    background: #fc5c65;
  }
</style>

